import { create, node } from '@dojo/framework/core/vdom';
const factory = create({ node });
export const canvasnode = factory(({ middleware: { node } }) => {
    return {
        get(key) {
            return node.get(key);
        }
    };
});
